const state = {
  pagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  endorsePagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  reservationPagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  tnkcBookedPaganation: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  guestListPagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  guestBookedPagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  },

  /* params */
  guestParams: {
    page: '',
    searchValue: '',
    searchKey: 'all', // default
    building: '',
    status: '',
    count: 10
  },

  endorseMentParams: {
    page: '',
    searchValue: '',
    searchKey: 'all', // default
    building: '',
    status: '',
    count: 10,
    batch_id: ''
  },

  reservationParams: {
    searchKey: 'all',
    page: '',
    searchValue: '',
    count: 10,
    status: ''
  },

  guestBookingParams: {
    // todo
    searchKey: 'all',
    page: '',
    searchValue: '',
    count: 10
  },

  userAccountPagination: {
    from: 1,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    to: 10,
    total: 0
  }
}

const mutations = {

  set_crew_pagination: (state, data) => {
    state.pagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_endorse_pagination: (state, data) => {
    state.endorsePagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_reservation_pagination: (state, data) => {
    state.reservationPagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_tnkc_booked_pagination: (state, data) => {
    state.tnkcBookedPaganation = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_guest_list_pagination: (state, data) => {
    state.guestListPagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_guest_booked_pagination: (state, data) => {
    state.guestBookedPagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  set_pagination_null: (state) => {
    state.pagination = {}
    state.endorsePagination = {}
    state.reservationPagination = {}
  },

  set_params_null: (state) => {
    state.params = {
      page: '',
      searchValue: '',
      searchKey: 'all', // default
      building: '',
      status: '',
      count: 10
    }
  },

  set_reset_tnkc_pagination (state) {
    state.tnkcBookedPaganation = {
      from: 1,
      currentPage: 1,
      lastPage: 0,
      perPage: 10,
      to: 10,
      total: 0
    }
  },

  set_reservation_params_null (state) {
    state.reservationParams = {
      searchKey: 'all',
      page: '',
      searchValue: '',
      count: 10,
      status: ''
    }
  },

  set_account_pagination (state, data) {
    state.userAccountPagination = {
      from: data.from,
      currentPage: data.current_page,
      lastPage: data.last_page,
      perPage: data.per_page,
      to: data.to,
      total: data.total
    }
  },

  reset_account_pagination (state) {
    state.userAccountPagination = {
      from: 1,
      currentPage: 1,
      lastPage: 0,
      perPage: 10,
      to: 10,
      total: 0
    }
  }
}

const actions = {
  setPaginationNull ({ commit }) {
    commit('set_pagination_null')
  },

  setParamsNull ({ commit }) {
    commit('set_params_null')
  },

  setResetTnkcBookedPagination ({ commit }) {
    commit('set_reset_tnkc_pagination')
  },

  setReservationParamsNull ({ commit }) {
    commit('set_reservation_params_null')
  }
}

const getters = {
  pagination: (state) => state.pagination,
  endorsePagination: (state) => state.endorsePagination,
  reservationPagination: state => state.reservationPagination,
  tnkcBookedPaganation: state => state.tnkcBookedPaganation,
  guestListPagination: state => state.guestListPagination,
  guestBookedPagination: state => state.guestBookedPagination,
  userAccountPagination: state => state.userAccountPagination,

  // params
  guestParams: state => state.guestParams,
  endorseMentParams: state => state.endorseMentParams,
  reservationParams: state => state.reservationParams,
  guestBookingParams: state => state.guestBookingParams
}

export default { state, actions, mutations, getters }
